// Verfügbare Sprachen
export const LANGUAGES = {
  de: { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  en: { code: 'en', name: 'English', flag: '🇬🇧' },
  it: { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  fr: { code: 'fr', name: 'Français', flag: '🇫🇷' }
};

export const translations = {
  de: {
    // Auth
    login: "Anmelden",
    signup: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    logout: "Abmelden",
    
    // Dashboard
    dashboard: "Dashboard",
    newDiagnosis: "Neue Diagnose",
    history: "Verlauf",
    myVehicles: "Meine Fahrzeuge",
    account: "Konto",
    
    // Vehicle
    vehicle: "Fahrzeug",
    brand: "Marke",
    model: "Modell",
    engine: "Motor",
    year: "Baujahr",
    vin: "VIN (optional)",
    addVehicle: "Fahrzeug hinzufügen",
    selectVehicle: "Fahrzeug auswählen",
    vehicleLibrary: "Fahrzeugdaten-Bibliothek",
    
    // Navigation
    vinDecoder: "VIN-Decoder",
    obdLive: "OBD Live",
    downloads: "Downloads",
    recommendations: "Empfehlungen",
    tuningConfig: "Tuning-Konfigurator",
    invoices: "Rechnungen",
    help: "Hilfe & Support",
    userManual: "Benutzerhandbuch",
    faq: "FAQ",
    settings: "Einstellungen",
    
    // Diagnosis
    diagnosis: "Diagnose",
    symptoms: "Symptome",
    describeSymptoms: "Beschreiben Sie die Symptome",
    startDiagnosis: "Diagnose starten",
    currentStep: "Aktueller Schritt",
    nextStep: "Nächster Schritt",
    complete: "Abschließen",
    
    // Results
    result: "Ergebnis",
    good: "Gut",
    bad: "Schlecht",
    unclear: "Unklar",
    note: "Notiz",
    addNote: "Notiz hinzufügen",
    
    // Upload
    upload: "Hochladen",
    uploadImage: "Bild hochladen",
    uploadVideo: "Video hochladen",
    uploadAudio: "Audio hochladen",
    
    // Report
    report: "Bericht",
    downloadReport: "Bericht herunterladen",
    finalDiagnosis: "Diagnose",
    repairGuide: "Reparaturanleitung",
    
    // Repairs
    repairs: "Reparaturen",
    repairVideos: "Reparatur-Videos",
    loadingVideos: "Suche Videos auf YouTube...",
    noVideosFound: "Keine passenden Videos gefunden",
    searchYoutube: "Auf YouTube suchen",
    moreOnYoutube: "Mehr auf YouTube",
    noGuides: "Keine Reparaturanleitungen vorhanden",
    
    // Admin
    admin: "Administration",
    theme: "Design",
    apiKeys: "API-Schlüssel",
    plans: "Abo-Pläne",
    disclaimers: "Haftungsausschlüsse",
    users: "Benutzer",
    systemServer: "System & Server",
    
    // Subscription
    subscription: "Abonnement",
    currentPlan: "Aktueller Plan",
    upgrade: "Upgrade",
    manage: "Verwalten",
    
    // Common
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolg",
    back: "Zurück",
    next: "Weiter",
    search: "Suchen",
    filter: "Filter",
    all: "Alle",
    refresh: "Aktualisieren",
    close: "Schließen",
    download: "Herunterladen",
  },
  en: {
    // Auth
    login: "Login",
    signup: "Sign Up",
    email: "Email",
    password: "Password",
    logout: "Logout",
    
    // Dashboard
    dashboard: "Dashboard",
    newDiagnosis: "New Diagnosis",
    history: "History",
    myVehicles: "My Vehicles",
    account: "Account",
    
    // Vehicle
    vehicle: "Vehicle",
    brand: "Brand",
    model: "Model",
    engine: "Engine",
    year: "Year",
    vin: "VIN (optional)",
    addVehicle: "Add Vehicle",
    selectVehicle: "Select Vehicle",
    vehicleLibrary: "Vehicle Database",
    
    // Navigation
    vinDecoder: "VIN Decoder",
    obdLive: "OBD Live",
    downloads: "Downloads",
    recommendations: "Recommendations",
    tuningConfig: "Tuning Configurator",
    invoices: "Invoices",
    help: "Help & Support",
    userManual: "User Manual",
    faq: "FAQ",
    settings: "Settings",
    
    // Diagnosis
    diagnosis: "Diagnosis",
    symptoms: "Symptoms",
    describeSymptoms: "Describe the symptoms",
    startDiagnosis: "Start Diagnosis",
    currentStep: "Current Step",
    nextStep: "Next Step",
    complete: "Complete",
    
    // Results
    result: "Result",
    good: "Good",
    bad: "Bad",
    unclear: "Unclear",
    note: "Note",
    addNote: "Add Note",
    
    // Upload
    upload: "Upload",
    uploadImage: "Upload Image",
    uploadVideo: "Upload Video",
    uploadAudio: "Upload Audio",
    
    // Report
    report: "Report",
    downloadReport: "Download Report",
    finalDiagnosis: "Final Diagnosis",
    repairGuide: "Repair Guide",
    
    // Repairs
    repairs: "Repairs",
    repairVideos: "Repair Videos",
    loadingVideos: "Searching YouTube for videos...",
    noVideosFound: "No matching videos found",
    searchYoutube: "Search on YouTube",
    moreOnYoutube: "More on YouTube",
    noGuides: "No repair guides available",
    
    // Admin
    admin: "Administration",
    theme: "Theme",
    apiKeys: "API Keys",
    plans: "Plans",
    disclaimers: "Disclaimers",
    users: "Users",
    systemServer: "System & Server",
    
    // Subscription
    subscription: "Subscription",
    currentPlan: "Current Plan",
    upgrade: "Upgrade",
    manage: "Manage",
    
    // Common
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    back: "Back",
    next: "Next",
    search: "Search",
    filter: "Filter",
    all: "All",
    refresh: "Refresh",
    close: "Close",
    download: "Download",
  },
  it: {
    // Auth
    login: "Accedi",
    signup: "Registrati",
    email: "Email",
    password: "Password",
    logout: "Esci",
    
    // Dashboard
    dashboard: "Dashboard",
    newDiagnosis: "Nuova diagnosi",
    history: "Cronologia",
    myVehicles: "I miei veicoli",
    account: "Account",
    
    // Vehicle
    vehicle: "Veicolo",
    brand: "Marca",
    model: "Modello",
    engine: "Motore",
    year: "Anno",
    vin: "VIN (opzionale)",
    addVehicle: "Aggiungi veicolo",
    selectVehicle: "Seleziona veicolo",
    vehicleLibrary: "Database veicoli",
    
    // Navigation
    vinDecoder: "Decodificatore VIN",
    obdLive: "OBD Live",
    downloads: "Download",
    recommendations: "Raccomandazioni",
    tuningConfig: "Configuratore Tuning",
    invoices: "Fatture",
    help: "Aiuto e supporto",
    userManual: "Manuale utente",
    faq: "FAQ",
    settings: "Impostazioni",
    
    // Diagnosis
    diagnosis: "Diagnosi",
    symptoms: "Sintomi",
    describeSymptoms: "Descrivi i sintomi",
    startDiagnosis: "Avvia diagnosi",
    currentStep: "Passaggio corrente",
    nextStep: "Prossimo passaggio",
    complete: "Completa",
    
    // Results
    result: "Risultato",
    good: "Buono",
    bad: "Cattivo",
    unclear: "Incerto",
    note: "Nota",
    addNote: "Aggiungi nota",
    
    // Upload
    upload: "Carica",
    uploadImage: "Carica immagine",
    uploadVideo: "Carica video",
    uploadAudio: "Carica audio",
    
    // Report
    report: "Rapporto",
    downloadReport: "Scarica rapporto",
    finalDiagnosis: "Diagnosi finale",
    repairGuide: "Guida riparazione",
    
    // Repairs
    repairs: "Riparazioni",
    repairVideos: "Video riparazione",
    loadingVideos: "Ricerca video su YouTube...",
    noVideosFound: "Nessun video trovato",
    searchYoutube: "Cerca su YouTube",
    moreOnYoutube: "Altri su YouTube",
    noGuides: "Nessuna guida disponibile",
    
    // Admin
    admin: "Amministrazione",
    theme: "Tema",
    apiKeys: "Chiavi API",
    plans: "Piani",
    disclaimers: "Disclaimer",
    users: "Utenti",
    systemServer: "Sistema e Server",
    
    // Subscription
    subscription: "Abbonamento",
    currentPlan: "Piano attuale",
    upgrade: "Upgrade",
    manage: "Gestisci",
    
    // Common
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    loading: "Caricamento...",
    error: "Errore",
    success: "Successo",
    back: "Indietro",
    next: "Avanti",
    search: "Cerca",
    filter: "Filtro",
    all: "Tutti",
    refresh: "Aggiorna",
    close: "Chiudi",
    download: "Scarica",
  },
  fr: {
    // Auth
    login: "Connexion",
    signup: "S'inscrire",
    email: "Email",
    password: "Mot de passe",
    logout: "Déconnexion",
    
    // Dashboard
    dashboard: "Tableau de bord",
    newDiagnosis: "Nouvelle diagnostic",
    history: "Historique",
    myVehicles: "Mes véhicules",
    account: "Compte",
    
    // Vehicle
    vehicle: "Véhicule",
    brand: "Marque",
    model: "Modèle",
    engine: "Moteur",
    year: "Année",
    vin: "VIN (optionnel)",
    addVehicle: "Ajouter véhicule",
    selectVehicle: "Sélectionner véhicule",
    vehicleLibrary: "Base de données véhicules",
    
    // Navigation
    vinDecoder: "Décodeur VIN",
    obdLive: "OBD Live",
    downloads: "Téléchargements",
    recommendations: "Recommandations",
    tuningConfig: "Configurateur Tuning",
    invoices: "Factures",
    help: "Aide et support",
    userManual: "Manuel utilisateur",
    faq: "FAQ",
    settings: "Paramètres",
    
    // Diagnosis
    diagnosis: "Diagnostic",
    symptoms: "Symptômes",
    describeSymptoms: "Décrivez les symptômes",
    startDiagnosis: "Démarrer diagnostic",
    currentStep: "Étape actuelle",
    nextStep: "Étape suivante",
    complete: "Terminer",
    
    // Results
    result: "Résultat",
    good: "Bon",
    bad: "Mauvais",
    unclear: "Incertain",
    note: "Note",
    addNote: "Ajouter note",
    
    // Upload
    upload: "Charger",
    uploadImage: "Charger image",
    uploadVideo: "Charger vidéo",
    uploadAudio: "Charger audio",
    
    // Report
    report: "Rapport",
    downloadReport: "Télécharger rapport",
    finalDiagnosis: "Diagnostic final",
    repairGuide: "Guide réparation",
    
    // Repairs
    repairs: "Réparations",
    repairVideos: "Vidéos de réparation",
    loadingVideos: "Recherche de vidéos sur YouTube...",
    noVideosFound: "Aucune vidéo trouvée",
    searchYoutube: "Rechercher sur YouTube",
    moreOnYoutube: "Plus sur YouTube",
    noGuides: "Aucun guide disponible",
    
    // Admin
    admin: "Administration",
    theme: "Thème",
    apiKeys: "Clés API",
    plans: "Plans",
    disclaimers: "Mentions légales",
    users: "Utilisateurs",
    systemServer: "Système et Serveur",
    
    // Subscription
    subscription: "Abonnement",
    currentPlan: "Plan actuel",
    upgrade: "Mise à niveau",
    manage: "Gérer",
    
    // Common
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    back: "Retour",
    next: "Suivant",
    search: "Rechercher",
    filter: "Filtrer",
    all: "Tous",
    refresh: "Actualiser",
    close: "Fermer",
    download: "Télécharger",
  }
};

export const useTranslation = (locale) => {
  const t = (key) => {
    return translations[locale]?.[key] || translations.de[key] || key;
  };
  
  return { t };
};
